module.exports = __webpack_public_path__ + "static/media/cpf-person-original-laranja.d97fc561.png";